import { DetailedList } from '@qbe/ads-blocks-forms';
import { Box, Typography } from '@qbe/ads-core';
import React from 'react';

import { useAppContent } from '~/hooks';
import { currencyFormatter } from '~/utils/currencyFormatter';

interface MonthlyPaymentDayProps {
  firstInstalment: number;
  futureInstalment: number;
}

const MonthlyPaymentDay: React.FC<MonthlyPaymentDayProps> = ({
  firstInstalment,
  futureInstalment,
}) => {
  const { getTextContent, getJSXContent } = useAppContent({
    basePath: 'dsme.payments.content.monthlyPaymentDay',
  });

  return (
    <Box textAlign="center">
      <Typography variant="subtitle2" component="h3" gutterBottom>
        {getTextContent('title')}
      </Typography>
      {getJSXContent('description')}
      <Box maxWidth="450px" margin="auto">
        <DetailedList
          list={[
            {
              id: 'firstInstalment',
              label: 'First Instalment',
              name: 'firstInstalment',
              value: currencyFormatter(firstInstalment),
            },
            {
              id: 'futureInstalments',
              label: 'Future Instalments',
              name: 'futureInstalments',
              value: currencyFormatter(futureInstalment),
            },
          ]}
          variant="multiple"
        />
      </Box>
    </Box>
  );
};

export default MonthlyPaymentDay;
